export const OWNER_ACTIONS = {
  SEND_REGISTRATION_LINK: 'SEND_REGISTRATION_LINK',
  SEND_SUBSCRIPTION_EMAIL: 'SEND_SUBSCRIPTION_EMAIL',
  CHANGE_PHONE: 'CHANGE_PHONE',
  CHANGE_EMAIL: 'CHANGE_EMAIL',
  DELETE: 'DELETE',
};
